import { Container } from '@mui/material';
import React, { useContext, useState } from 'react';
import usePatientsForVisit_Bl from './hooks/usePatientsForVisit_Bl';
import DataFilters from './components/DataFilters';
import PatientCardList from './components/PatientCardList';
import PatientSearchBox from '../CurrentPatients/Components/PatientSearchBox/PatientSearchBox';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import useFocusOnLastSelectedPatient from './hooks/useFocusOnLastSelectedPatient';

const PatientsForVisit = () => {
  const [searchClause, setSearchClause] = useState('');
  const languageArray =
    useContext(GlobalContext)?.LanguageArray;

  const {
    setInputFilter,
    setRange,
    patientList,
    inputParams,
    inputFilter_label,
    noData_label,
  } = usePatientsForVisit_Bl(searchClause);

  useFocusOnLastSelectedPatient();


  console.log('patientList--->',patientList)


 
  return (
    <React.Fragment>
      <Container sx={{ p: '1em' }}>
        <PatientSearchBox
          setSearchAndDeliver={setSearchClause}
          languageArray={languageArray}
          disableObjOutPut={true}
        />
        <DataFilters
          setInputFilter={setInputFilter}
          setRange={setRange}
          inputParams={inputParams}
          inputFilter_label={inputFilter_label}
          noData_label={noData_label}
        />
        <PatientCardList
          patientList={patientList}
          noData_label={noData_label}
        />
      </Container>
    </React.Fragment>
  );
};

export default PatientsForVisit;
